function getLessonNumber(data, key) {
  const arr = data?.map(({ lessons }) => lessons)
  const position = arr?.flat().findIndex(({ title: lessonTile, slug }) => (
    lessonTile === key || slug === key
  ))
  return position + 1
}

export default getLessonNumber

